import styles from "./back-button.module.less";
import PropTypes from "prop-types";
import { runKeyDownOnEnter } from "components/helpers/interaction-helper";

const BackButton = (props) => {
  return (
    <div
      tabIndex={0}
      role="button"
      onClick={props.onClick}
      onKeyDown={(e) => runKeyDownOnEnter(e, props.onClick)}
      className={styles.wrapper}
    >
      <div className={styles.iconWrapper}>
        <span className={props.icon} />
      </div>
      {props.text && <p className={styles.text}>{props.text}</p>}
    </div>
  );
};

BackButton.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
};

BackButton.defaultProps = {
  icon: "icon-chevron-left",
  text: "Tillbaka",
};
export default BackButton;
